// A shopper who leaves contact info once unlocks every lead wall at that dealership for an hour — across scans.
const key = (dealerId) => `vx-unlock-${dealerId}`;

export function getUnlock(dealerId) {
  if (!dealerId) return null;
  try {
    const raw = localStorage.getItem(key(dealerId));
    if (!raw) return null;
    const saved = JSON.parse(raw);
    if (!saved.token || new Date(saved.expires_at).getTime() <= Date.now()) {
      localStorage.removeItem(key(dealerId));
      return null;
    }
    return saved;
  } catch {
    return null;
  }
}

export function saveUnlock(dealerId, lead) {
  if (!dealerId || !lead?.unlock_token) return;
  try {
    localStorage.setItem(key(dealerId), JSON.stringify({ token: lead.unlock_token, expires_at: lead.unlock_expires_at }));
  } catch {
    /* private mode */
  }
}
